import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Button, Pagination, Breadcrumb } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgiconsLogo1 from '../../../assets/images/course/icon-01.svg'
import imgiconsLogo2 from '../../../assets/images/abouts/iconlog-2.png'
import imgiconsLogo3 from '../../../assets/images/course/icon-03.svg'
import imgiconsLogo4 from '../../../assets/images/course/icon-04.svg'
// import imgiconsLogo3 from '../../../assets/images/abouts/iconlog-3.png'
// import imgiconsLogo4 from '../../../assets/images/abouts/iconlog-4.png'
import { changeFormatdate } from '../../../utils/formatdate'
import Search from '../../../components/user/Search'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import CourseDetail from '../../../components/user/CourseDetail'
import { 
   getIsTrial, 
} 
from '../../../utils/auth'

const { Text, Title } = Typography
const { Meta } = Card;
class Policy extends React.Component {

    state = {
        detailData: [],
        detailDataShow:[],
        preLoadDetailData: true,
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        offset: 0,
        limit: 3,
        current: 1
    }

    fetchCourse = async (search) => {
        const { client,location ,match } = this.props
        const { offset ,limit } = this.state

        await this.setState({
            preLoadDetailData:true
        })


        const { data, errors } = await client.query({
            query: Queries.fetchCourseList,
            variables: {
                // search,
                // courseCategory: match.url.split('/')[2]
                courseCategory: "WORK",
                // offset, 
                // limit 
            }
        })

        console.log('errors',errors)
        
        //////////////////addmodalINTERNAL_SERVER_ERROR
        // if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
        //     await this.setState({
        //         showModalErrors: true
        //     })
        // }

        if(data.fetchCourse){
            await this.setState({
                detailData: data.fetchCourse,
                preLoadDetailData:false
            })
        }

        await this.dataPagination()
    }

    dataPagination = async () =>{
        const { offset, detailDataShow, detailData } = this.state

        console.log('cvxvxvc',detailData)
        if(detailData.length !== 0){
            if(detailData.data){
                const res = [];
                for (let i = 0; i < detailData.data.length; i += 3) {
                    const chunk = detailData.data.slice(i, i + 3);
                    res.push(chunk);
                }

                await this.setState({
                    detailDataShow:res
                })
            }
        }
        
        // let ssss = chunk(detailData.data,3)
    }

    onChangePage = async page => {
		const { type, limit } = this.state
		let newoffset = limit * (page - 1)
		await this.setState({
			current: page,
			offset: newoffset,
		});
		await this.fetchCourse()
	};

    fetchUrlConicleMyPolicy = async() =>{
        const { client,location ,match } = this.props

        const { data, errors } = await client.query({
            query: Queries.fetchUrlConicleMyPolicy,
        })

        if(data.fetchUrlConicleMyPolicy){
            window.open(data.fetchUrlConicleMyPolicy.url, "_blank")
        }
    }

    fetchUrlConicleAllPolicy = async() =>{
        const { client,location ,match } = this.props

        const { data, errors } = await client.query({
            query: Queries.fetchUrlConicleAllPolicy,
        })

        if(data.fetchUrlConicleAllPolicy){
            window.open(data.fetchUrlConicleAllPolicy.url, "_blank")
        }
    }

    fetchUrlConicleRequestPolicy = async() =>{
        const { client,location ,match } = this.props

        const { data, errors } = await client.query({
            query: Queries.fetchUrlConicleRequestPolicy,
        })

        if(data.fetchUrlConicleRequestPolicy){
            window.open(data.fetchUrlConicleRequestPolicy.url, "_blank")
        }
    }

    async componentDidMount() {
        await this.fetchCourse(null)
    }

    render() {
        const { match, location } = this.props
        const { detailData, limit, current, preLoadDetailData, detailDataShow, offset } = this.state
        console.log('getIsTrial',!getIsTrial() ? "null" : getIsTrial())
        return (
            <Container match={match} >
               
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-course">
                    {
                        getIsTrial() !== "true" ?
                           <>
                              {
                                 ( detailData.length !== 0 && detailData.total !== 0 ) &&
                                    <>
                                       {
                                             // <CourseDetail
                                             //     detailBox={ detailData.data }
                                             //     limit={limit}
                                             // />
                                             <CourseDetail
                                                detailBox={ detailDataShow.length !== 0 ? detailDataShow[current-1]  : [] }
                                                limit={limit}
                                             />
                                       }
                                    </>
                                 ||
                                 preLoadDetailData &&
                                 <Row>
                                    <Col span={24} align="center">
                                       <Spin />
                                    </Col>
                                 </Row>
                              }
                           </>
                        : ''
                    }
                    {
                       getIsTrial() !== "true" &&
                           ( detailData.length !== 0 && detailData.total !== 0 ) &&
                           <Pagination 
                              className="pt-4 paginationred" 
                              style={{ textAlign: 'right' }} 
                              current={current} 
                              onChange={this.onChangePage} 
                              defaultCurrent={1} 
                              total={detailData.total} 
                              pageSize={3} 
                           />
                    }
                    <div className="mt-5">
                        <Row gutter={24}>
                            <Col span={5}>
                                <div  style={{ cursor:"pointer" }}>
                                    <Card
                                        className="pt-4 pb-0"
                                        hoverable
                                        style={{ width: "100%", textAlign:"center" }}
                                        cover={<img alt="example" src={imgiconsLogo1} style={{ height:"140px" }} />}
                                        onClick={ () => this.fetchUrlConicleMyPolicy() }
                                    >
                                        <Meta title="หลักสูตรของฉัน" />
                                    </Card>
                                </div>
                            </Col>
                            {
                              getIsTrial() !== "true" ?
                                 <Col span={5}>
                                    <div  style={{ cursor:"pointer" }}>
                                          <Card
                                             className="pt-4 pb-0"
                                             hoverable
                                             style={{ width: "100%", textAlign:"center" }}
                                             cover={<img alt="example" src={imgiconsLogo4} style={{ height:"140px" }} />}
                                             onClick={ () => this.fetchUrlConicleAllPolicy() }
                                          >
                                             <Meta title="หลักสูตรทั้งหมด" />
                                          </Card>
                                    </div>
                                 </Col>
                              : ''
                           }
                        </Row>
                    </div>
                </div>
            </Container>
        )
    }
}

Policy.propTypes = {
    //
}

export default withApollo(Policy)